import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { cloneDeep, merge } from 'lodash';
import SocketClient from '../services/socketClient';
import LoggedUserContext from './LoggedUserContext';

const defaultBadge = {
  chatTypes: { bot: 0, individual: 0, group: 0 },
  chat: 0,
  games: 0,
  validations: 0,
  wall: 0,
  inbox: 0,
  notifications: 0,
  faq: 0,
  taskValidations: 0,
  total: 0,
};

const BadgeContext = React.createContext(null);
BadgeContext.displayName = 'BadgeContext';

export function BadgeContextProvider(props) {
  const { children } = props;

  const { loggedUser } = useContext(LoggedUserContext);

  const [badge, setBadge] = useState(defaultBadge);

  const handleBadgeChange = useCallback(badgeData => {
    setBadge({ ...merge(cloneDeep(defaultBadge), badgeData) });
  }, []);

  useEffect(() => {
    let subscribed = true;
    if (loggedUser) {
      SocketClient.on('BADGE', handleBadgeChange);
      axios
        .get('/api/badge', {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Games',
          },
        })
        .then(({ data: response }) => {
          if (subscribed) {
            setBadge(response.data);
          }
        });
    }

    return () => {
      subscribed = false;
      SocketClient.off('BADGE', handleBadgeChange);
    };
  }, [handleBadgeChange, loggedUser]);

  return (
    <BadgeContext.Provider value={{ badge, updateBadge: setBadge }}>
      {children}
    </BadgeContext.Provider>
  );
}

BadgeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useBadge() {
  return useContext(BadgeContext);
}

export function useClearBadge() {
  const { updateBadge } = useBadge() || {};

  return useCallback(() => {
    if (updateBadge) {
      updateBadge(defaultBadge);
    }
  }, [updateBadge]);
}
